module.exports = __webpack_public_path__ + "images/courses-nav.png";


//////////////////
// WEBPACK FOOTER
// ./vively/images/courses-nav.png
// module id = 858
// module chunks = 3